import React from 'react';
import Layouts from '../../layouts/Layouts';
import LayoutsKasir from '../../layouts/LayoutsKasir';

function HistorySaldoKasir() {
  return <LayoutsKasir>HistorySaldoKasir</LayoutsKasir>;
}

export default HistorySaldoKasir;
